import './style.css'
import React, { useContext } from 'react'
import TopBar from '../organisms/topBar/view'
import Sidebar from '../organisms/sidebar/view'
import { roleContext } from '../../context/role/context'
import { useSidebar } from '../../context/sidebar/SidebarContext'
import { useLocation } from 'react-router-dom'
import { AIFloatingButton } from '../atoms/AIFloatingButton/AIFloatingButton'
import { AIChatDrawer } from '../organisms/AIChatDrawer/AIChatDrawer'
import { useAIChat } from '../../usecases/useAIChat'

function GeneralLayout({ child }) {
    const { profile, suscripcion } = useContext(roleContext)
    const { collapsed } = useSidebar()
    const location = useLocation()
    const roleId = profile?.colaborador?.role_id ?? profile?.role_id
    const isCashier = roleId === 3
    const isPos = location.pathname === '/pos' || location.pathname.startsWith('/pos') || location.hash.includes('pos') || isCashier

    const {
        isOpen,
        toggleOpen,
        closeChat,
        messages,
        isLoading,
        mode,
        currentView,
        userName,
        error,
        sendMessage,
        clearMessages
    } = useAIChat()

    const sidebarWidth = (isPos || isCashier) ? '0px' : (collapsed ? 'var(--sidebar-collapsed)' : 'var(--sidebar-width)')

    return (
        <div className="layout-wrapper">
            {!isPos && !isCashier && <Sidebar />}
            <TopBar profile={profile} />
            <div
                className='general-layout'
                style={{
                    paddingLeft: sidebarWidth,
                    transition: 'padding-left var(--sidebar-transition)'
                }}
            >
                {React.cloneElement(child, { profile, suscripcion })}
            </div>

            {/* Asistente Flotante de IA y Drawer Global (se oculta para cajeros y en POS) */}
            {!isPos && !isCashier && (
                <>
                    <AIFloatingButton onClick={toggleOpen} isOpen={isOpen} />
                    <AIChatDrawer
                        isOpen={isOpen}
                        onClose={closeChat}
                        messages={messages}
                        isLoading={isLoading}
                        mode={mode}
                        currentView={currentView}
                        userName={userName}
                        onSendMessage={sendMessage}
                        onClearChat={clearMessages}
                        error={error}
                    />
                </>
            )}
        </div>
    )
}

export default GeneralLayout
